import * as React from 'react';
import { cn } from '../../../../utils/tailwind';

interface DropdownMenuPropsInterface {
    children: React.ReactNode;
    maxHeight?: number;
}

export const DropdownMenu: React.FC<DropdownMenuPropsInterface> = ({ children, maxHeight }) => {
    return (
        <ul
            className={cn('m-0 flex flex-col p-0', !!maxHeight && 'overflow-y-auto')}
            style={maxHeight ? { maxHeight: `${maxHeight}rem` } : undefined}
        >
            {children}
        </ul>
    );
};
